/* Native "Add-ons" block for Denta-M / Ella theme.
   Merchant picks up to 5 companion products via the block's theme-editor
   settings. Checking one or more boxes and then clicking the page's own
   native "In den Warenkorb legen" button adds the main product AND every
   checked add-on together, in ONE /cart/add.js request. No app, no extra
   network call for the widget itself.

   Deliberately theme-agnostic (does not rely on globals/classes from any
   other theme's implementation of this feature):
   - Uses the raw fetch("/cart/add.js") endpoint directly rather than any
     window.routes.* global.
   - Hooks the *button click* (capture phase) on every add-to-cart button
     for this product, rather than assuming a single form/button pair or a
     specific data-action attribute this theme may not use.
   - Refreshes the cart drawer the same way already confirmed to work on
     this theme elsewhere in the project: clicking the header cart icon
     (.header__icon--cart) re-renders it with live cart contents.
   - If nothing is checked, does nothing at all and lets the click proceed
     exactly as before (zero behavior change for products without add-ons,
     or with the block present but unchecked). */
(function () {
    function getFormsForProduct(productId) {
        return Array.prototype.filter.call(
            document.querySelectorAll('form[action="/cart/add"]'),
            function (form) {
                var id = form.getAttribute('id') || '';
                // Exclude the installment/Klarna-style form; only the real
                // add-to-cart forms (main + sticky) should trigger add-ons.
                if (id.indexOf('installment') !== -1) return false;
                return id.indexOf('-' + productId) !== -1;
            }
        );
    }

    function getButtonsForForm(form) {
        return Array.prototype.slice.call(
            form.querySelectorAll('[data-btn-addtocart], button[name="add"]')
        );
    }

    function getCheckedAddons(root) {
        return Array.prototype.slice.call(
            root.querySelectorAll('.product-addons__input:checked')
        );
    }

    function setBusy(root, busy) {
        root.querySelectorAll('.product-addons__input').forEach(function (input) {
            input.disabled = busy;
        });
    }

function setInnerHTMLWithScripts(el, html) {
    el.innerHTML = html;
    el.querySelectorAll('script').forEach(function (oldScript) {
        var newScript = document.createElement('script');
        Array.prototype.forEach.call(oldScript.attributes, function (attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
}

function openCartDrawer() {
    var routesRoot = (window.routes && window.routes.root) || '';

    fetch(routesRoot + '/cart?view=ajax_side_cart', { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
            var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
            if (wrapper) setInnerHTMLWithScripts(wrapper, html);
            document.body.classList.add('cart-sidebar-show');
        })
        .catch(function () {
            // Fallback, in case the drawer markup ever changes.
            var trigger = document.querySelector('.header__icon--cart');
            if (trigger) trigger.click();
        });

    fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
            });
        })
        .catch(function () {});
}

    function getMainQuantity(form) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        return value > 0 ? value : 1;
    }

    function getMainVariantId(form) {
        var idInput = form.querySelector('input[name="id"]');
        return idInput ? idInput.value : null;
    }

    function submitWithAddons(root, form, button) {
        var checked = getCheckedAddons(root);
        var mainVariantId = getMainVariantId(form);
        if (!mainVariantId) return false;

        var items = [{ id: mainVariantId, quantity: getMainQuantity(form) }];
        checked.forEach(function (input) {
            var variantId = input.getAttribute('data-variant-id');
            if (variantId) items.push({ id: variantId, quantity: 1 });
        });

        setBusy(root, true);
        if (button) button.disabled = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.json().then(function (data) {
                        throw new Error((data && data.description) || 'Add to cart failed');
                    });
                }
                return response.json();
            })
            .then(function () {
                openCartDrawer();
            })
            .catch(function (error) {
                // Fail safe: fall back to a plain native submit of just the
                // main product, so the shopper isn't blocked from buying at
                // all if something about the add-ons request goes wrong.
                console.error('[product-addons]', error);
                form.submit();
            })
            .finally(function () {
                setBusy(root, false);
                if (button) button.disabled = false;
            });

        return true;
    }

    function initProductAddons(root) {
        if (!root || root.getAttribute('data-pa-init') === 'true') return;
        root.setAttribute('data-pa-init', 'true');

        var productId = root.getAttribute('data-product-id');
        var forms = getFormsForProduct(productId);

        forms.forEach(function (form) {
            getButtonsForForm(form).forEach(function (button) {
                button.addEventListener(
                    'click',
                    function (event) {
                        var checked = getCheckedAddons(root);
                        if (!checked.length) return; // nothing selected: behave exactly as before
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        submitWithAddons(root, form, button);
                    },
                    true
                );
            });
        });
    }

    function initAll(scope) {
        (scope || document).querySelectorAll('[data-product-addons]').forEach(initProductAddons);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }

    // Re-init after theme editor section re-renders.
    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();